import { render, staticRenderFns } from "./Appealrecord.vue?vue&type=template&id=5567a305&scoped=true"
import script from "./Appealrecord.vue?vue&type=script&lang=js"
export * from "./Appealrecord.vue?vue&type=script&lang=js"
import style0 from "./Appealrecord.vue?vue&type=style&index=0&id=5567a305&prod&scoped=true&lang=css"
import style1 from "./Appealrecord.vue?vue&type=style&index=1&id=5567a305&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5567a305",
  null
  
)

export default component.exports